var map = {
	"./Hawk and man.svg": "c617",
	"./bag.png": "7e8a",
	"./bag.svg": "3128",
	"./baklava.png": "ae97",
	"./baklava.svg": "6924",
	"./bjkjersey.svg": "5b93",
	"./boho_rio_gift_crown.svg": "eae3",
	"./boho_rio_gift_dancer.svg": "d45e",
	"./boho_rio_gift_disco.svg": "a4cb",
	"./boho_rio_gift_drink.svg": "3686",
	"./boho_rio_gift_drum.svg": "d955",
	"./boho_rio_gift_flower.svg": "2ea4",
	"./boho_rio_gift_guitar.svg": "208b",
	"./boho_rio_gift_heart.svg": "3111",
	"./boho_rio_gift_mask.svg": "05d0",
	"./boho_rio_gift_samba-1.svg": "ada7",
	"./boho_rio_gift_samba.svg": "1207",
	"./boho_rio_gift_woman.svg": "988e",
	"./bohodiamond.png": "d4c0",
	"./bohodiamond.svg": "2169",
	"./bouquet_gift.svg": "c5c3",
	"./brazil_woman.svg": "397b",
	"./broken-heart.svg": "d631",
	"./bunny.gif": "46e7",
	"./bunny.svg": "7363",
	"./burger.svg": "7c75",
	"./cake.svg": "7a59",
	"./cake_gift_v2.svg": "4cae",
	"./candies.gif": "7834",
	"./candies.svg": "17ee",
	"./candycane.png": "da47",
	"./candycane.svg": "094b",
	"./car.png": "d480",
	"./car.svg": "f81a",
	"./carrot.svg": "0bb7",
	"./carrots.gif": "fc71",
	"./champagne.png": "da31",
	"./champagne.svg": "7e6a",
	"./cheers.png": "1252",
	"./cheers.svg": "cc68",
	"./chocolate-box.svg": "9f86",
	"./chocolate_box_gift.svg": "9ffd8",
	"./christmascouple.svg": "ff0c",
	"./christmashat.png": "822d",
	"./christmashat.svg": "0bc5",
	"./christmassweater.png": "ca21",
	"./christmassweater.svg": "67f0",
	"./christmastree.png": "cc57",
	"./christmastree.svg": "d38e",
	"./cocktail.png": "4bd3",
	"./cocktail.svg": "dccb",
	"./coctail.svg": "0aa5",
	"./coffee.svg": "7ea3",
	"./coffee_gift.svg": "22d2",
	"./cup.svg": "d2e3",
	"./diamond-ring.svg": "a48c",
	"./dollarcoin.png": "1193",
	"./dollarcoin.svg": "4228",
	"./donut.png": "7ef6",
	"./donut.svg": "54c9",
	"./easter.gif": "8f2c",
	"./evileyetalisman.png": "a6ee",
	"./evileyetalisman.svg": "688d",
	"./fbjersey.svg": "5ba5",
	"./fireball.svg": "991f",
	"./football.svg": "680e",
	"./gift.svg": "c460",
	"./gift_box.svg": "a9a9",
	"./goal1.svg": "390b",
	"./goal2.svg": "e3b8",
	"./gold-ingot.svg": "d218",
	"./gsjersey.svg": "2aea",
	"./halloween_balloons.svg": "0092",
	"./halloween_bat.svg": "e990",
	"./halloween_boo.svg": "814e",
	"./halloween_candy.svg": "f7e9",
	"./halloween_cupcake.svg": "e198",
	"./halloween_ghost.svg": "1772",
	"./halloween_happy.svg": "1d75",
	"./halloween_lovepotion.svg": "a939",
	"./halloween_pumpkin.svg": "72c0",
	"./happy_easter.svg": "bce3",
	"./happy_holidays.svg": "6f44",
	"./happynewyear.png": "9a4a",
	"./happynewyear.svg": "f0b5",
	"./hawk-and-man.svg": "a044",
	"./heart.svg": "4500",
	"./holiday_message.gif": "8a93",
	"./hookah.png": "0958",
	"./hookah.svg": "5114",
	"./hug.png": "f868",
	"./hug.svg": "4153",
	"./ice-cream.svg": "fcb6",
	"./key.png": "0661",
	"./key.svg": "c6bd",
	"./kiss.svg": "d102",
	"./lemonade.svg": "adf0",
	"./liberty.svg": "ac17",
	"./lipstick_gift.svg": "c59c",
	"./loading_heart_gift.svg": "42a2",
	"./love-balloon.png": "6203",
	"./love-balloon.svg": "bbef",
	"./love_lock_gift.svg": "df6e",
	"./love_potion_gift.svg": "b429",
	"./man_gift.svg": "3d5c",
	"./mena-camel.svg": "f1a6",
	"./mena-hawk.svg": "1323",
	"./mena-hurma.svg": "d7ca",
	"./mena-lamp.svg": "ddd1",
	"./mena-man.svg": "892d",
	"./mena-moon.svg": "d908",
	"./mena-vimto.svg": "1b79",
	"./mena-woman.svg": "d637",
	"./necklace.png": "6b61",
	"./necklace.svg": "8a49",
	"./newyear.png": "cecf",
	"./newyear.svg": "a3df",
	"./noelcouple.png": "e2b4",
	"./noelcouple.svg": "2e2f",
	"./ny_tree.svg": "8e9f",
	"./orchid.png": "7c36",
	"./party_mask.svg": "75b3",
	"./pretzel.svg": "ea1c",
	"./punnet.svg": "927c",
	"./ring_gift.svg": "f252",
	"./rose-bouqet.svg": "478b",
	"./rose.svg": "e33b",
	"./santa_claus.svg": "1024",
	"./snowman.png": "a2c7",
	"./snowman.svg": "4031",
	"./star.png": "4c66",
	"./star.svg": "ef79",
	"./streaming_butterfly.svg": "b278",
	"./streaming_champagne.svg": "6821",
	"./streaming_dove.svg": "3dfb",
	"./streaming_flowers.svg": "fa4b",
	"./streaming_hot.svg": "da24",
	"./streaming_kupid.svg": "72ee",
	"./streaming_moto.svg": "d7b5",
	"./streaming_princess.svg": "a9a3",
	"./streaming_rabbit.svg": "97e2",
	"./streaming_rabbit_clouds.svg": "524a",
	"./tea.svg": "b3e6",
	"./teddy-bear.png": "7096",
	"./teddy-bear.svg": "41a5",
	"./tsjersey.svg": "6b22",
	"./turkish_delight.gif": "b263",
	"./turkish_delight.svg": "b9a7",
	"./user_photo.svg": "8c7f",
	"./user_video.svg": "6626",
	"./v1_cup.svg": "db0b",
	"./v1_gift_box.svg": "2915",
	"./v1_ny_tree.svg": "283b",
	"./v1_santa_claus.svg": "6e54",
	"./v1_woman.svg": "2009",
	"./v2_cup.svg": "1354",
	"./v2_gift_box.svg": "4f89",
	"./v2_ny_tree.svg": "689a",
	"./v2_santa_claus.svg": "8ec9",
	"./v2_woman.svg": "1219",
	"./vd-cupids-arrow.svg": "25ae",
	"./vd-date-of-love.svg": "a49d",
	"./vd-kiss.svg": "c32e",
	"./vd-lollipop.svg": "d30d",
	"./vd-love-letter.svg": "0813",
	"./vd-love-potion.svg": "97e6",
	"./vd-lover-birds.svg": "d0f7",
	"./vd-milkshake.svg": "7931",
	"./vd-valentines-day.svg": "8cb5",
	"./vosvos.svg": "cbf1",
	"./wedding-ring.svg": "7e59",
	"./woman.svg": "ce24",
	"./woman_gift.png": "afe8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2ada";